import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import PropertiesPage from "@/pages/PropertiesPage";
import StaysPage from "@/pages/StaysPage";
import RentalsPage from "@/pages/RentalsPage";
import PropertyDetailPage from "@/pages/PropertyDetailPage";
import ValuationPage from "@/pages/ValuationPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PropertyManagementPage from "@/pages/PropertyManagementPage";
import RealEstatePage from "@/pages/RealEstatePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import SavedPropertiesPage from "@/pages/SavedPropertiesPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import RegionsPage from "@/pages/RegionsPage";
import RegionDetailPage from "@/pages/RegionDetailPage";
import SubAreaDetailPage from "@/pages/SubAreaDetailPage";
import NotFoundPage from "@/pages/NotFoundPage";

// Layout
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ScrollToTop from "@/components/ScrollToTop";

// Contexts
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import { SiteImagesProvider } from "@/contexts/SiteImagesContext";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <CurrencyProvider>
        <SiteImagesProvider>
        <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Admin Routes - No navbar/footer */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          
          {/* Public Routes */}
          <Route path="/*" element={
            <>
              <ScrollToTop />
              <Navbar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/properties" element={<PropertiesPage />} />
                  <Route path="/stays" element={<StaysPage />} />
                  <Route path="/rentals" element={<RentalsPage />} />
                  <Route path="/properties/:slug" element={<PropertyDetailPage />} />
                  <Route path="/sell" element={<ValuationPage />} />
                  <Route path="/valuation" element={<ValuationPage />} />
                  <Route path="/property-management" element={<PropertyManagementPage />} />
                  <Route path="/real-estate" element={<RealEstatePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/saved" element={<SavedPropertiesPage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/blog/:slug" element={<BlogPostPage />} />
                  <Route path="/regions" element={<RegionsPage />} />
                  <Route path="/region/:slug" element={<RegionDetailPage />} />
                  <Route path="/region/:regionSlug/:subSlug" element={<SubAreaDetailPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </main>
              <Footer />
              <WhatsAppButton />
            </>
          } />
        </Routes>
      </BrowserRouter>
      </SiteImagesProvider>
      </CurrencyProvider>
    </div>
  );
}

export default App;
